var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42859 10H1.57139C0.703606 10 0 9.312 0 8.463V6.54165C0 6.32949 0.176002 6.15746 0.392773 6.15746H1.17862C1.39553 6.15746 1.57139 6.32949 1.57139 6.54165V7.69449C1.57139 8.11898 1.92313 8.46301 2.35709 8.46301H8.6429C9.07687 8.46301 9.42859 8.11898 9.42859 7.69449V6.54165C9.42859 6.32949 9.60447 6.15746 9.8215 6.15746H10.6072C10.8241 6.15746 11 6.32949 11 6.54165V8.46301C11 9.312 10.2965 10 9.42859 10ZM2.30633 2.46113C2.46526 2.3057 2.72312 2.3057 2.88206 2.46113L4.71444 4.25342V0.384365C4.71444 0.172201 4.89034 0 5.10722 0H5.89291C6.10985 0 6.28584 0.172201 6.28584 0.384365V4.25342L8.11821 2.46113C8.27715 2.3057 8.53489 2.3057 8.69382 2.46113L9.26965 3.02441C9.42858 3.17987 9.42858 3.43195 9.26965 3.58754L6.02495 6.76129C6.01092 6.77498 5.75848 6.92592 5.50446 6.92603C5.24768 6.92615 4.98935 6.77514 4.9753 6.76129L1.73047 3.58754C1.57152 3.43194 1.57152 3.17987 1.73047 3.02441L2.30633 2.46113Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveIcon);
export default __webpack_public_path__ + "static/media/receiveIcon.944b49a012ff0c1cce4df4b828b3d430.svg";
export { ForwardRef as ReactComponent };